module.exports = __webpack_public_path__ + "static/media/before.50743398.png";